import { render, staticRenderFns } from "./ProductCardContent.vue?vue&type=template&id=45071967&"
import script from "./ProductCardContent.vue?vue&type=script&lang=js&"
export * from "./ProductCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports